import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@app/../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {
  private endpoint: string = `${environment.apiUrl}`;
  constructor(private _http: HttpClient) { }

  onReadTotalValue(){
      return this._http.get<any>(`${this.endpoint}/statistics`);
  }

  onDashboardStatictics(){
    return this._http.get<any>(`${this.endpoint}/dashboard-statistics`);
  }

  onGetDashboardVideos(){
    return this._http.get<any>(`${this.endpoint}/dashboard-videos`);
  }
}
